import { type ClassValue, clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

type AdditionalClassGroupIds = 'custom-text' | 'custom-link';
type AdditionalThemeGroupIds = never;

/**
 * Function to create merge function with custom config which extends the default config.
 * This is necessary for any custom class groups or theme groups in our tailwind.config.ts.
 *
 * @see https://github.com/dcastil/tailwind-merge/blob/main/docs/api-reference.md#extendtailwindmerge
 */
const twMerge = extendTailwindMerge<AdditionalClassGroupIds, AdditionalThemeGroupIds>({
  extend: {
    classGroups: {
      // TODO: Not working as intended at the moment but please keep up to date
      'custom-text': [
        'body',
        'body-strong',
        'body2',
        'body2-strong',
        'body3',
        'body3-strong',
        'body4',
        'sub',
        'subhead-tight',
        'homepage-subhead1',
        'header-sans-tight',
      ],
      'custom-link': [
        'link-body',
        'link-body2',
        'link-body3',
        'link-nav-light',
        'link-nav-dark',
        'link-dashed-header',
        'link-dashed-body',
        'link-dashed-body2',
        'link-dashed-body3',
      ],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
